<div class="product-order-item" *ngIf="_orderItem && product && _order && initialized"
    [ngClass]="[containerCSSClass, isItemCutOW ? 'item_cut' : '']">
    <ng-container *ngTemplateOutlet="modal ? modalView: (readonly && tabletDevice) ? mobileReadOnlyView: desktopView">
    </ng-container>
</div>

<!--Item cancel or shipment cancel message template -->
<ng-template #cancelMessage let-itemCancelled="itemCancelled" let-cancelled="cancelled">
    <ng-container *ngIf="itemCancelled; else shipmentCancelled">
        <div class="text-uppercase text-danger font-weight-bold pl-3">
            Item has been cancelled. Please remove from your cart.
        </div>
    </ng-container>
    <ng-template #shipmentCancelled>
        <div *ngIf="cancelled" class="text-uppercase text-danger font-weight-bold pl-3">
            Shipment has been cancelled for this item.
        </div>
    </ng-template>
</ng-template>

<ng-template #desktopView>
    <div class="product-order-item__row" [ngClass]="[containerCSSClass, isItemCutOW ? 'item_cut' : '']">
        <div class="image" *ngIf="product.media && viewType === 'list-item'">
            <img [src]="product.media | thumbnail" [alt]="product.label">
        </div>

        <div class="header--wrapper">
            <!-- Render cancel message -->
            <ng-container *ngTemplateOutlet="cancelMessage; context: { itemCancelled: itemCancelled, cancelled: cancelled }"></ng-container>
            <!--header-->
            <app-product-order-item-header [orderItem]="_orderItem"
                                           [order]="_order"
                                           [viewType]="viewType"
                                           [showHideItemButton]="showHideItemButton"
                                           [showReorderButton]="showReorderButton"
                                           [showCustomizationButton]="showCustomizationButton"
                                           [readonly]="readonly" [modal]="modal"
                                           (changedVisibility)="onOrderItemChangeVisibility($event)"
                                           (editted)="onEdited($event)" (reorderItem)="reorderItem()">
            </app-product-order-item-header>

            <ng-container *ngIf="!mobileDevice">
              <ng-container *ngTemplateOutlet="placeOrderView"></ng-container>
            </ng-container>
        </div>

    </div>
    <ng-container *ngIf="mobileDevice">
      <ng-container *ngTemplateOutlet="placeOrderMobileView"></ng-container>
    </ng-container>



</ng-template>

<ng-template #modalView>
    <div class="modal-container">
        <div class="product--container">

            <div class="product-details--mobile">
                <ng-container *ngTemplateOutlet="productDetailsView"></ng-container>
            </div>

            <div class="product-gallery bottom_line">
                <div class="product-gallery--box">
                    <product-gallery [product]="product" [modalView]="true" ></product-gallery>
                </div>


            </div>
            <div class="product-description py-3 bottom_line"
                [innerHTML]="(product?.content?.description || '' )| truncate: 300 | safeContent ">
            </div>
            <div *ngIf="eudrFooterMessageText" class="mt-2">
                {{ eudrFooterMessageText }}
            </div>
            <div *ngIf="eudrFooterMessageText" class="mt-2">
                {{ eudrFooterMessageText }}
            </div>
        </div>
        <div class="order-item--container">

            <div class="product-details--desktop">
                <ng-container *ngTemplateOutlet="productDetailsView"></ng-container>
            </div>

            <div>
                <ng-container *ngTemplateOutlet="placeOrderView"></ng-container>
            </div>

        </div>
    </div>
    <a *ngIf="!readonly" class="d-block link link-underline small text-align-center my-3"
        (click)="redirectToFullProduct()" href="javascript:void(0)">View Full Item Details</a>
</ng-template>

<ng-template #productDetailsView>
    <div class="bottom_line pb-2 px-3">
        <span *ngIf="isItemCutOW" class="text-danger font-weight-bold">{{ 'This item has been cut' | uppercase }}</span>
        <h1 class="product-label my-0" [innerHTML]="product.label | safeContent "></h1>
        <div class="mb-2">
            <app-product-item-number [itemNumber]="product.skus[0].getDisplaySkuID()"
                [supplierId]="product.hasVariations ? null : product.skus[0].supplierId"></app-product-item-number>
        </div>
        <div class="product-meta">
            <div>

                <app-product-order-item-min-max *ngIf="showMinOrderInHeader"
                    [shouldShowAvailableQuantity]="!product.hasVariations" [isRecommended]="isProductRecommended"
                    [headerPosition]="true" [orderItem]="_orderItem" [viewType]="viewType" fontSize="font-4">
                </app-product-order-item-min-max>
                <app-on-demand-min-max [orderItem]="_orderItem" [viewType]="viewType"></app-on-demand-min-max>

                <app-product-recommened-quantity *ngIf="isProductRecommended"
                    [recommendedQty]="product.recommended_qty_expected"
                    [currentQty]="product.recommended_qty_current"></app-product-recommened-quantity>
                <div *ngIf="!this.readonly && !product.hasVariations && !product.isBuyingWindow"
                    class="availability--container">
                    <div class="d-flex flex-column">
                        <app-product-order-item-in-stock *ngIf="!product.isEnabledAllocatedInventory"
                                [product]="product" [quantity]="_orderItem.quantity"
                                                     [viewType]="viewType" fontSize="font-4"
                                                         class="availability--container"></app-product-order-item-in-stock>

                        <app-inventory-allocation-status *ngIf="!product.hasVariations && product.isEnabledAllocatedInventory"
                                                         [product]="_orderItem.product">
                        </app-inventory-allocation-status>
                    </div>
                </div>

            </div>
            <div class="price--container pr-3">
                <app-product-order-item-price *ngIf="!product.hasVariations"
                    [orderItem]="_orderItem" [ngClass]="'list-item'" [modal]="modal" fontSize="font-3">
                </app-product-order-item-price>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #placeOrderView>
    <div *ngIf="product.hasVariations && canOrder && !showVariations" class="pb-3">
        <button class="btn btn-primary float-right" (click)="redirectToFullProduct()" type="button"
            name="update">Product Detail</button>
        <p class="variation-message">This product has variations. Please use the product detail to order this item</p>
    </div>



    <div *ngIf="!product.hasVariations || showVariations">
        <!-- delivery items -->
        <ng-container *ngIf="delivery && _orderItem.hidden === false">
            <app-product-order-item-delivery [delivery]="delivery"
                                             [product]="product"
                                             [viewType]="viewType"
                                             [order]="_order"
                                             [orderItem]="_orderItem"
                                             [readonly]="readonly"
                                             [cartReadonlyPerformanceMode]="cartReadonlyPerformanceMode"
                                             [precomputedEudrRestricted]="checkoutPrecomputedEudrRestriction(delivery)"
                                             [showEditControls]="showEditControls"
                                             [totals]="totalCost"
                                             [showTotalInline]="!showTotals"
                                             [isFirstShipment]= "true"
                                             [isLastShipment]="true"
                                             [canAddAnotherAddress]="canAddAddress"
                                             [showTrackingInfo]="showTrackingInfo"
                                             [canRemoveAddress]="canRemoveAddress"
                                             [paidQuantity]="paidQuantity"
                                             (customizationChanged)="onCustomizationChanged($event)"
                                             (deliverToChanged)="onDeliveryChanged($event)"
                                             (changed)="onOrderItemChanged($event)"
                                             (orderItemSubmitRequired)="handleOrderItemSubmitRequired($event)"
                                             [refreshingTrackingStatus]="refreshingTrackingStatus"
                                             (refreshStatus)="refreshTrackingStatus()"
                                             (restrictionChange)="onRestrictionChange($event)"
            >
            </app-product-order-item-delivery>
        </ng-container>
        <ng-container *ngIf="!delivery &&  _orderItem.hidden === false">
            <!-- When DL is active: DL deliveries + Additional Addresses section -->
            <ng-container *ngIf="orderHasDistributionList; else allDeliveriesView">
                <app-product-order-item-delivery *ngFor="let dlDelivery of dlDeliveries; let i = index; trackBy: trackByDeliveryUuid"
                                                 [delivery]="dlDelivery"
                                                 [product]="product"
                                                 [viewType]="viewType"
                                                 [order]="_order"
                                                 [orderItem]="_orderItem"
                                                 [readonly]="readonly"
                                                 [cartReadonlyPerformanceMode]="cartReadonlyPerformanceMode"
                                                 [precomputedEudrRestricted]="checkoutPrecomputedEudrRestriction(dlDelivery)"
                                                 [showEditControls]="showEditControls"
                                                 [totals]="totalCost"
                                                 [showTotalInline]="!showTotals"
                                                 [showTrackingInfo]="showTrackingInfo"
                                                 [isFirstShipment]="i === 0"
                                                 [isLastShipment]="i === dlDeliveries.length - 1"
                                                 [canAddAnotherAddress]="canAddAddress"
                                                 [canRemoveAddress]="false"
                                                 (customizationChanged)="onCustomizationChanged($event)"
                                                 (changed)="onOrderItemChanged($event)"
                                                 (orderItemSubmitRequired)="handleOrderItemSubmitRequired($event)"
                                                 (refreshStatus)="refreshTrackingStatus()"
                                                 [refreshingTrackingStatus]="refreshingTrackingStatus"
                                                 (deliverToChanged)="onDeliveryChanged($event)"
                                                 (restrictionChange)="onRestrictionChange($event)"
                ></app-product-order-item-delivery>

                <!-- Additional Addresses divider -->
                <div class="order-item__additional-addresses-divider" *ngIf="!readonly && additionalDeliveries && additionalDeliveries.length > 0">
                    <span>ADDITIONAL ADDRESSES</span>
                </div>

                <app-product-order-item-delivery *ngFor="let addDelivery of additionalDeliveries; let i = index; trackBy: trackByDeliveryUuid"
                                                 [delivery]="addDelivery"
                                                 [product]="product"
                                                 [viewType]="viewType"
                                                 [order]="_order"
                                                 [orderItem]="_orderItem"
                                                 [readonly]="readonly"
                                                 [cartReadonlyPerformanceMode]="cartReadonlyPerformanceMode"
                                                 [precomputedEudrRestricted]="checkoutPrecomputedEudrRestriction(addDelivery)"
                                                 [showEditControls]="showEditControls"
                                                 [totals]="totalCost"
                                                 [showTotalInline]="!showTotals"
                                                 [showTrackingInfo]="showTrackingInfo"
                                                 [isFirstShipment]="i === 0"
                                                 [isLastShipment]="i === additionalDeliveries.length - 1"
                                                 [canAddAnotherAddress]="canAddAddress"
                                                 [canRemoveAddress]="true"
                                                 (customizationChanged)="onCustomizationChanged($event)"
                                                 (changed)="onOrderItemChanged($event)"
                                                 (orderItemSubmitRequired)="handleOrderItemSubmitRequired($event)"
                                                 (refreshStatus)="refreshTrackingStatus()"
                                                 [refreshingTrackingStatus]="refreshingTrackingStatus"
                                                 (deliverToChanged)="onDeliveryChanged($event)"
                                                 (restrictionChange)="onRestrictionChange($event)"
                ></app-product-order-item-delivery>
            </ng-container>

            <ng-template #allDeliveriesView>
                <app-product-order-item-delivery *ngFor="let delivery of getActualDeliveries(); let i = index; trackBy: trackByDeliveryUuid"
                                                 [delivery]="delivery"
                                                 [product]="product"
                                                 [viewType]="viewType"
                                                 [order]="_order"
                                                 [orderItem]="_orderItem"
                                                 [readonly]="readonly"
                                                 [cartReadonlyPerformanceMode]="cartReadonlyPerformanceMode"
                                                 [precomputedEudrRestricted]="checkoutPrecomputedEudrRestriction(delivery)"
                                                 [showEditControls]="showEditControls"
                                                 [totals]="totalCost"
                                                 [showTotalInline]="!showTotals"
                                                 [showTrackingInfo]="showTrackingInfo"
                                                 [isFirstShipment]="i === 0"
                                                 [isLastShipment]="getActualDeliveries().length === i + 1"
                                                 [canAddAnotherAddress]="canAddAddress"
                                                 [canRemoveAddress]="getActualDeliveries().length > 1 && canRemoveAddress"
                                                 (customizationChanged)="onCustomizationChanged($event)"
                                                 (changed)="onOrderItemChanged($event)"
                                                 (orderItemSubmitRequired)="handleOrderItemSubmitRequired($event)"
                                                 (refreshStatus)="refreshTrackingStatus()"
                                                 [refreshingTrackingStatus]="refreshingTrackingStatus"
                                                 (deliverToChanged)="onDeliveryChanged($event)"
                                                 (restrictionChange)="onRestrictionChange($event)"
                ></app-product-order-item-delivery>
            </ng-template>
        </ng-container>
    </div>

    <ng-container *ngIf="(!readonly && canOrder); else readonlyContainer">
        <!--  add another address (non-DL orders) -->
        <div class="order-item__add-address" *ngIf="canAddAddress && !orderHasDistributionList">
            <button class="btn btn-link underline p-0" (click)="addAnotherAddress()">
                {{addressLabel}} <i class="fas fa-plus"></i>
            </button>
        </div>
        <!--  add additional address (DL orders) -->
        <div class="order-item__add-address" *ngIf="canAddAddress && orderHasDistributionList">
            <button class="btn btn-link p-0" (click)="addAdditionalAddress()">
                Add another address <i class="fas fa-plus"></i>
            </button>
        </div>

        <!-- product variations-->
        <div *ngIf="product.hasVariations && showVariations" class="order-item__variations">
          <div *ngFor="let sku of product.skus" class="edit--order-item__variations--grid"
            [class.hide-grid-col-2]="hideOnDemandSkuAllocationControl">

            <ng-container  class="align-items-center order-item__variations--item" *ngIf="{ outOfStock: isInventoryAllocationOutOfStock$(sku.id) | async } as vm">

              <!--Input for quantity-->
              <div class="order-item__variations--input grid-col-1">
                <input [min]="0" digitOnly type="number" (change)="updateOrderItemVariation(sku)"
                   [(ngModel)]="_orderItem.getVariationSKU(sku.id).quantity" [disabled]="!canAddQuantity(vm.outOfStock)">
              </div>

              <!--On-demand allocation control for SKU-->
              <div class="grid-col-2" [class.col-hidden]="hideOnDemandSkuAllocationControl">
                <app-sku-inventory-allocation-control [skuId]="sku.id" [orderItem]="_orderItem"
                                                      [delivery]="availableDelivery"
                                                      [disabled]="!canEditOrderItems"
                                                      (onSelectAllocationGroup)="onAllocationGroupChanged($event)">
                </app-sku-inventory-allocation-control>
              </div>


              <!--SKU Description-->
              <div class="grid-col-3">
                <div class="order-item__variations--description font-4 font-weight-bold">
                  <ul class="my-0">
                    <li *ngFor="let label of getVariationLabel(sku)">{{label}}</li>
                    <li *ngIf="sku.urn" class="font-weight-normal font-5">URN: {{sku.urn}}</li>
                    <li *ngIf="getVariationCodeInfo(sku) as codeInfo" class="font-weight-normal font-5">
                      {{codeInfo.label}}: {{codeInfo.value}}
                    </li>
                  </ul>
                </div>
              </div>


              <!--SKU Details (min/max, available qty, in stock)-->
              <div class="grid-col-4">
                <div class="order-item__variations--detailes text-align-right">
                  <app-inventory-allocation-status [product]="product"
                                                   [skuId]="sku.id"></app-inventory-allocation-status>

                  <app-product-order-item-in-stock *ngIf="!product.isBuyingWindow && !product.isEnabledAllocatedInventory" [product]="product" [sku]="sku"
                                                   fontSize="font-5" viewType="sku-item" class="mb-2"></app-product-order-item-in-stock>
                  <app-product-order-item-min-max *ngIf="showMinOrderInBody(sku)" [orderItem]="_orderItem"
                                                  [product]="product" [showQuantityInSeparateLine]="true" [headerPosition]="false" [sku]="sku"
                                                  viewType="detailed" fontSize="font-5">
                  </app-product-order-item-min-max>
                  <app-on-demand-sku-available-qty [orderItem]="_orderItem" [product]="product" [sku]="sku"
                                                   viewType="detailed" fontSize="font-5"></app-on-demand-sku-available-qty>
                </div>
              </div>


              <!--SKU Price-->
              <div class="grid-col-5">
                <div class="order-item__variations--price">
                  <app-product-order-item-price [sku]="sku" [orderItem]="_orderItem"
                                                fontSize="font-4"></app-product-order-item-price>
                </div>
              </div>
          </ng-container>
        </div>
      </div>





        <!--  total quantity and cost-->
        <div class="order-item__total mt-3" *ngIf="showTotals">
            <div class="col-3 order-item__total--quantity">
                <div>
                    <label class="label">Total Qty</label>
                    <p class="font-weight-bold" [ngClass]="{'strikethrough': isItemCutOW || false }">{{ _originalOrderItem.quantity }}</p>
                </div>
            </div>
            <div class="col-6">
                <!-- budgets-->
                <ng-container *ngIf="showBudget && budgets && budgets.length > 0 && canSeeBudgets">
                    <label class="label text-left">Budget Available</label>
                    <ng-select class="ng-select--budgets" [items]="budgets" placeholder="Choose a budget"
                        [readonly]="budgets.length === 1" dropdownPosition="bottom" [searchable]="false"
                        [clearable]="false" bindValue="id" (change)="changeBudget($event)" name="budget"
                        [(ngModel)]="selectedBudgetId">
                        <ng-template ng-label-tmp let-item="item">
                            <div class="font-5" *ngIf="selectedBudget">
                                <div class="font-weight-bold text-left">{{ selectedBudget.label }}</div>
                                <div class="text-left" *ngIf="selectedBudget.id > 0">
                                    <span class="price d-inline font-weight-normal"><app-currency-price
                                            [isItemCut]="isItemCutOW" [price]="selectedBudget.balance"
                                            [currency]="orderCurrency"></app-currency-price></span> (Expires {{
                                    selectedBudget.end_at | dateFormat }})
                                </div>
                            </div>

                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <div class="font-6">
                                <div class="font-weight-bold text-left">{{ item.label }}</div>
                                <div class="text-left" *ngIf="item.id > 0">
                                    <span class="price d-inline font-weight-normal"><app-currency-price
                                            [price]="item.balance" [isItemCut]="isItemCutOW"
                                            [currency]="orderCurrency"></app-currency-price></span> (Expires {{
                                    item.end_at | dateFormat }})
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                    <p *ngIf="isBudgetExhausted" class="font-5 color-red ng-star-inserted text-align-left mt-2">
                        {{ budgets[0].label }} is exhausted. Please alter existing order quantities to add more.
                    </p>
                </ng-container>
            </div>
            <div class="col-3 order-item__total--cost">
                <div class="">
                    <label class="label">Total Cost</label>
                    <span class="font-1 font-weight-bold price">
                        <app-product-price *ngIf="hasValidDiscount"  [price]="_orderItem.totalCost"
                                           [originalPrice]="_orderItem.totalCost + _orderItem.totalDiscount"
                                           [showBothPrices]="_orderItem.totalDiscount > 0"
                                           [currency]="orderCurrency"></app-product-price>

                        <app-currency-price *ngIf="!hasValidDiscount" [isItemCut]="isItemCutOW"
                                            [price]="financialTotalCost"
                                            [currency]="orderCurrency"></app-currency-price>
                    </span>
                    <a *ngIf="!readonly" class="link link-underline font-5  font-weight-normal btn-price-details"
                        (click)="viewPriceDetails()" href="javascript:void(0)">View Details</a>
                </div>
            </div>
        </div>

        <!--    add to cart-->
        <div class="order-item__update" *ngIf="!product.hasVariations || showVariations">
            <div *ngIf="product.window_id > 0 && product.in_stock" class="order-item__update--buy-now mt-2">
                <div>
                    <span>Need it sooner?</span>
                    <a class="link underline" routerLink="/on-demand/products/{{ product.in_stock_slug }}">Buy It
                        Now</a>
                </div>
            </div>

            <div class="order-item__update--cta">

                <div class="cta--container" [ngStyle]="{'align-items': showLeaseWarning ? 'flex-start' : 'center'}">
                    <div *ngIf="showLeaseWarning" class="mr-2">
                        <div class="text-center">
                            <p class="p-0 m-0">A Lease Agreement is required to order this item.</p>
                            <a class="link small link-underline" href="{{ leaseAgreementUrl }}" target="_blank">Click
                                here to Apply</a>
                            <div class="text-center mt-3">
                                <p class="m-0 p-0">Already applied?</p>
                                <a class="link small link-underline" href="#" (click)="checkLeaseStatus()">Check your
                                    status
                                    <i class="fal fa-sync rotate ml-2" *ngIf="checkingLease"></i>
                                </a>
                                <ng-container *ngIf="leaseResult">
                                    <p class="m-0 p-0 red" *ngIf="leaseResult !== product.attr_capex_type">A Lease
                                        Agreement has not been approved for this product.</p>
                                    <p class="m-0 p-0 green" *ngIf="leaseResult === product.attr_capex_type">A Lease
                                        Agreement has been approved for this product.</p>
                                </ng-container>
                            </div>
                        </div>


                    </div>
                    <div *ngIf="purchaseResult.added" class="purchase-result mr-2">Your item was successfully added to
                        your <a class="link link-underline small" (click)="redirectToShoppingCart()"
                            href="javascript:void(0)">shopping cart</a> </div>
                    <div *ngIf="purchaseResult.updated" class="purchase-result mr-2">Your item was successfully updated
                        in your <a class="link link-underline small" (click)="redirectToShoppingCart()"
                            href="javascript:void(0)">shopping cart</a> </div>
                    <div *ngIf="purchaseResult.deleted" class="purchase-result  mr-2">Your item has been removed from
                        your <a class="link link-underline small" (click)="redirectToShoppingCart()"
                            href="javascript:void(0)">Shopping cart</a> </div>

                        <ng-container *ngIf="{ disabled: isOutOfStock$ | async } as vm">
                            <span class="d-inline-flex ml-auto mr-3"
                                  [class.disabled-tooltip-wrapper]="buttonIsDisabled(vm.disabled)"
                                  [ngbTooltip]="purchaseButtonTitle || null"
                                  [disableTooltip]="!buttonIsDisabled(vm.disabled)"
                                  tooltipClass="single-line-tooltip"
                                  placement="bottom"
                                  [attr.tabindex]="buttonIsDisabled(vm.disabled) ? '0' : null"
                                  [attr.role]="buttonIsDisabled(vm.disabled) ? 'button' : null"
                                  [attr.aria-disabled]="buttonIsDisabled(vm.disabled) ? 'true' : null">
                                <button *ngIf="canOrder" [disabled]="buttonIsDisabled(vm.disabled)"
                                        [title]="purchaseButtonTitle"
                                        (click)="saveWithDelay()" type="button"
                                        class="btn btn-primary btn-purchase">
                                    <i *ngIf="orderItemUpdating" class="fal fa-sync rotate mr-2"></i>
                                    <span>{{isItemInCart ? 'Update': 'Add To Cart'}}</span>
                                </button>
                            </span>
                        </ng-container>
                    </div>

                <div class="mt-3 pr-3">
                    <app-favorite-toggle [product]="product" [isUpdating]="updatingFavorites"
                        (toggleFavorite)="onToggleFavorites($event)" (close)="onClose()"></app-favorite-toggle>
                </div>
            </div>
        </div>
        <div class="mt-3 text-align-left" *ngIf="canShowProductPurchaseDetails">
            <app-product-orders-details [productId]="product.id" [modal]="modal"
                (showFull)="redirectToFullProduct()"></app-product-orders-details>
        </div>
    </ng-container>
</ng-template>


<ng-template #placeOrderMobileView>
    <div class="order-item__decision-point bottom_line mt-3"
        *ngIf="!readonly && isDecisionPointOrder && !product.hasVariations && (product.window_id > 0 || !product.inventoryType || product.inStock || _orderItem.deliveries.length > 0)">
        <div *ngIf="dpSummaryData" class="d-flex flex-column align-items-center">
            <button (click)="showDpModal()" type="button" class="btn btn-outline-primary" [disabled]="!canShowDPModal">
                <span>Update Decision Point Quantity</span>
            </button>
            <p class="text-center mt-2 color--primary-grey font-4">{{ dpSummaryData.eligible_wslr_count }} Wholesalers
                and {{ dpSummaryData.store_count }} Stores&nbsp;<button class="btn btn-icon"
                    (click)="showDPFaqDialog()"><i class="fas fa-exclamation-circle"></i></button></p>
        </div>
        <div *ngIf="loadingSummaryData">
            <app-infinite-progress [inProgress]="true"></app-infinite-progress>
        </div>
    </div>

    <div class="order-item__decision-point bottom_line"
        *ngIf="!readonly && isDecisionPointOrder && product.hasVariations">
        <p class="mt-3 color-red">Currently you cannot order by Decision Point for items with sizes or variations. Thank
            you for your patience.</p>
    </div>


    <div *ngIf="product.hasVariations && canOrder && !showVariations" class="pb-3">
        <button class="btn btn-primary float-right" (click)="redirectToFullProduct()" type="button"
            name="update">Product Detail</button>
        <p class="variation-message">This product has variations. Please use the product detail to order this item</p>
    </div>



    <div *ngIf="!product.hasVariations || showVariations">
        <!--    delivery items-->
        <ng-container *ngIf="delivery && _orderItem.hidden === false">
            <app-product-order-item-delivery [delivery]="delivery"
                                             [product]="product"
                                             [viewType]="viewType"
                                             [order]="_order"
                                             [orderItem]="_orderItem"
                                             [readonly]="readonly"
                                             [cartReadonlyPerformanceMode]="cartReadonlyPerformanceMode"
                                             [precomputedEudrRestricted]="checkoutPrecomputedEudrRestriction(delivery)"
                                             [showEditControls]="showEditControls"
                                             [totals]="totalCost"
                                             [showTotalInline]="!showTotals"
                                             [isFirstShipment]= "true"
                                             [isLastShipment]="true"
                                             [canAddAnotherAddress]="canAddAddress"
                                             [showTrackingInfo]="showTrackingInfo"
                                             [canRemoveAddress]="!isDecisionPointOrder"
                                             [paidQuantity]="paidQuantity"
                                             (customizationChanged)="onCustomizationChanged($event)"
                                             (deliverToChanged)="onDeliveryChanged($event)"
                                             (changed)="onOrderItemChanged($event)"
                                             (orderItemSubmitRequired)="handleOrderItemSubmitRequired($event)"
                                             [refreshingTrackingStatus]="refreshingTrackingStatus"
                                             (refreshStatus)="refreshTrackingStatus()"
                                             (restrictionChange)="onRestrictionChange($event)"
            >
            </app-product-order-item-delivery>

        </ng-container>
        <ng-container *ngIf="!delivery &&  _orderItem.hidden === false">
            <app-product-order-item-delivery *ngFor="let delivery of getActualDeliveries(); let i = index; trackBy: trackByDeliveryUuid"
                                             [delivery]="delivery"
                                             [product]="product"
                                             [viewType]="viewType"
                                             [order]="_order"
                                             [orderItem]="_orderItem"
                                             [readonly]="readonly"
                                             [cartReadonlyPerformanceMode]="cartReadonlyPerformanceMode"
                                             [precomputedEudrRestricted]="checkoutPrecomputedEudrRestriction(delivery)"
                                             [showEditControls]="showEditControls"
                                             [totals]="totalCost"
                                             [showTotalInline]="!showTotals"
                                             [showTrackingInfo]="showTrackingInfo"
                                             [isFirstShipment]= "i === 0"
                                             [isLastShipment]="getActualDeliveries().length === i + 1"
                                             [canAddAnotherAddress]="canAddAddress"
                                             [canRemoveAddress]="getActualDeliveries().length > 1 && !isDecisionPointOrder"
                                             (customizationChanged)="onCustomizationChanged($event)"
                                             (changed)="onOrderItemChanged($event)"
                                             (orderItemSubmitRequired)="handleOrderItemSubmitRequired($event)"
                                             (refreshStatus)="refreshTrackingStatus()"
                                             [refreshingTrackingStatus]="refreshingTrackingStatus"
                                             (deliverToChanged)="onDeliveryChanged($event)"
                                             (restrictionChange)="onRestrictionChange($event)"
            ></app-product-order-item-delivery>

        </ng-container>

    </div>

    <ng-container *ngIf="(!readonly && canOrder); else readonlyContainer">
        <!--  add another address-->
        <div class="order-item__add-address" *ngIf="canAddAddress">
            <a class="link link-underline" (click)="!isItemCutOW && addAnotherAddress()" href="javascript:void(0)">
                {{addressLabel}}&nbsp;<i class="fas fa-plus"></i>
            </a>
        </div>

        <!-- product variations mobile  view-->
        <div *ngIf="product.hasVariations && showVariations"
            class="order-item__variations full-width">
            <ng-container *ngFor="let sku of product.skus">

              <ng-container *ngIf="!hideOnDemandSkuAllocationControl" >
                <ng-container   *ngTemplateOutlet="skuDescription; context: { sku: sku }" ></ng-container>
              </ng-container>

                <div class="align-items-center order-item__variations--item  mt-3 border-bottom pb-2 mr-3">
                    <div class="col-3 order-item__variations--input px-0 pr-3">
                        <input [min]="0" digitOnly type="number" (change)="updateOrderItemVariation(sku)"
                            [(ngModel)]="_orderItem.getVariationSKU(sku.id).quantity" [disabled]="!canAddQuantity">
                    </div>
                    <div class="col-5 px-0">
                      <ng-container *ngIf="!hideOnDemandSkuAllocationControl">
                        <app-sku-inventory-allocation-control  [skuId]="sku.id" [orderItem]="_orderItem"
                                                              [delivery]="availableDelivery"
                                                              [disabled]="!canEditOrderItems"
                                                              (onSelectAllocationGroup)="onAllocationGroupChanged($event)">
                        </app-sku-inventory-allocation-control>
                      </ng-container>
                      <ng-container *ngIf="hideOnDemandSkuAllocationControl">
                        <ng-container   *ngTemplateOutlet="skuDescription; context: { sku: sku }" ></ng-container>
                      </ng-container>

                    </div>
                    <div class="col-4 order-item__variations--price px-0">
                        <app-product-order-item-price [sku]="sku" [orderItem]="_orderItem"
                            fontSize="font-4"></app-product-order-item-price>
                    </div>
                </div>
            </ng-container>
        </div>

        <!--  total quantity and cost-->
        <div class="order-item__total mt-3" *ngIf="showTotals">
            <div class="col-3 order-item__total--quantity px-0 pr-3">
                <div>
                    <label class="label">Total Qty</label>
                    <p class="font-weight-bold">{{ _originalOrderItem.quantity }}</p>
                </div>
            </div>
            <div class="col-6 px-0 pr-3">
                <!--    budgets-->
                <ng-container *ngIf="showBudget && budgets && budgets.length > 0 && canSeeBudgets">
                    <label class="label text-left">Budget Available</label>
                    <ng-select class="ng-select--budgets" [items]="budgets" placeholder="Choose a budget"
                        [readonly]="budgets.length === 1" dropdownPosition="bottom" [searchable]="false"
                        [clearable]="false" bindValue="id" (change)="changeBudget($event)" name="budget"
                        [(ngModel)]="selectedBudgetId">
                        <ng-template ng-label-tmp let-item="item">
                            <div class="font-5" *ngIf="selectedBudget">
                                <div class="font-weight-bold text-left">{{ selectedBudget.label }}</div>
                                <div class="text-left" *ngIf="selectedBudget.id > 0">
                                    <span class="price d-inline font-weight-normal"><app-currency-price
                                            [isItemCut]="isItemCutOW" [price]="selectedBudget.balance"
                                            [currency]="orderCurrency"></app-currency-price></span> (Expires {{
                                    selectedBudget.end_at | dateFormat }})
                                </div>
                            </div>

                        </ng-template>
                        <ng-template ng-option-tmp let-item="item">
                            <div class="font-6">
                                <div class="font-weight-bold text-left">{{ item.label }}</div>
                                <div class="text-left" *ngIf="item.id > 0">
                                    <span class="price d-inline font-weight-normal"><app-currency-price
                                            [price]="item.balance" [isItemCut]="isItemCutOW"
                                            [currency]="orderCurrency"></app-currency-price></span> (Expires {{
                                    item.end_at | dateFormat }})
                                </div>
                            </div>
                        </ng-template>
                    </ng-select>
                    <p *ngIf="isBudgetExhausted" class="font-5 color-red ng-star-inserted text-align-left mt-2">
                        {{ budgets[0].label }} is exhausted. Please alter existing order quantities to add more.
                    </p>
                </ng-container>
            </div>
            <div class="col-3 order-item__total--cost px-0">
                <div>
                    <label class="label">Total Cost</label>
                    <span class="font-1 font-weight-bold price">
                        <app-product-price *ngIf="hasValidDiscount"  [price]="_orderItem.totalCost"
                                           [originalPrice]="_orderItem.totalCost + _orderItem.totalDiscount"
                                           [showBothPrices]="_orderItem.totalDiscount > 0"
                                           [currency]="orderCurrency"></app-product-price>

                        <app-currency-price *ngIf="!hasValidDiscount" [isItemCut]="isItemCutOW"
                                            [price]="financialTotalCost"
                                            [currency]="orderCurrency"></app-currency-price>
                    </span>
                    <a *ngIf="!readonly" class="link link-underline font-5  font-weight-normal btn-price-details"
                        (click)="viewPriceDetails()" href="javascript:void(0)">View Details</a>
                </div>
            </div>
        </div>

        <!--    add to cart-->
        <div class="order-item__update" *ngIf="!product.hasVariations || showVariations">
            <div *ngIf="product.window_id > 0 && product.in_stock" class="order-item__update--buy-now mt-2">
                <div>
                    <span>Need it sooner?</span>
                    <a class="link underline" routerLink="/on-demand/products/{{ product.in_stock_slug }}">Buy It
                        Now</a>
                </div>
            </div>

            <div class="order-item__update--cta">

                <div *ngIf="showLeaseWarning" class="mt-3">
                    <div class="text-center">
                        <p class="p-0 m-0">A Lease Agreement is required to order this item.</p>
                        <a class="link small link-underline" href="{{ leaseAgreementUrl }}" target="_blank">Click here
                            to Apply</a>
                        <div class="text-center mt-3">
                            <p class="m-0 p-0">Already applied?</p>
                            <a class="link small link-underline" href="#" (click)="checkLeaseStatus()">Check your status
                                <i class="fal fa-sync rotate ml-2" *ngIf="checkingLease"></i>
                            </a>
                            <ng-container *ngIf="leaseResult">
                                <p class="m-0 p-0 red" *ngIf="leaseResult !== product.attr_capex_type">A Lease Agreement
                                    has not been approved for this product.</p>
                                <p class="m-0 p-0 green" *ngIf="leaseResult === product.attr_capex_type">A Lease
                                    Agreement has been approved for this product.</p>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="cta--container">
                    <div *ngIf="purchaseResult.added" class="purchase-result mr-2">Your item was successfully added to
                        your <a class="link link-underline small" (click)="redirectToShoppingCart()"
                            href="javascript:void(0)">shopping cart</a> </div>
                    <div *ngIf="purchaseResult.updated" class="purchase-result mr-2">Your item was successfully updated
                        in your <a class="link link-underline small" (click)="redirectToShoppingCart()"
                            href="javascript:void(0)">shopping cart</a> </div>
                    <div *ngIf="purchaseResult.deleted" class="purchase-result  mr-2">Your item has been removed from
                        your <a class="link link-underline small" (click)="redirectToShoppingCart()"
                            href="javascript:void(0)">Shopping cart</a> </div>

                    <ng-container *ngIf="{ disabled: isOutOfStock$ | async } as vm">
                        <span class="d-inline-flex ml-auto mr-0"
                              [class.disabled-tooltip-wrapper]="buttonIsDisabled(vm.disabled)"
                              [ngbTooltip]="purchaseButtonTitle || null"
                              [disableTooltip]="!buttonIsDisabled(vm.disabled)"
                              tooltipClass="single-line-tooltip"
                              placement="bottom"
                              [attr.tabindex]="buttonIsDisabled(vm.disabled) ? '0' : null"
                              [attr.role]="buttonIsDisabled(vm.disabled) ? 'button' : null"
                              [attr.aria-disabled]="buttonIsDisabled(vm.disabled) ? 'true' : null">
                            <button *ngIf="canOrder" [disabled]="buttonIsDisabled(vm.disabled)"
                                    [title]="purchaseButtonTitle"
                                    (click)="saveWithDelay()" type="button"
                                    class="btn btn-primary btn-purchase">
                                <i *ngIf="orderItemUpdating" class="fal fa-sync rotate mr-2"></i>
                                <span>{{ _orderItem.id ? 'Update' : 'Add To Cart' }}</span>
                            </button>
                        </span>
                    </ng-container>
                </div>

                <div class="mt-3 pr-0">
                    <app-favorite-toggle [product]="product" [isUpdating]="updatingFavorites"
                        (toggleFavorite)="onToggleFavorites($event)" (close)="onClose()"></app-favorite-toggle>
                </div>
            </div>
        </div>

        <div class="mt-3 text-align-left" *ngIf="canShowProductPurchaseDetails">
            <app-product-orders-details [productId]="product.id"></app-product-orders-details>
        </div>
    </ng-container>
</ng-template>

<ng-template #disabledButton>
    <button *ngIf="canOrder" disabled type="button"
        class="btn btn-primary btn-purchase ml-auto mr-0 disabled">
        <i *ngIf="orderItemUpdating" class="fal fa-sync rotate mr-2"></i>
        <span>{{ _orderItem.id ? 'Update' : 'Add To Cart' }}</span>
    </button>
</ng-template>

<ng-template #readonlyContainer>
    <ng-container *ngIf="canOrder">
        <ng-container *ngTemplateOutlet="mobileDevice ? mobileTotalsContainer : desktopTotalsContainer"></ng-container>
    </ng-container>
</ng-template>

<ng-template #desktopTotalsContainer>
    <div class="mt-3 ml-2" [ngStyle]="{'visibility': hideFinancials ? 'hidden': 'initial'}"  *ngIf="_orderItem.hidden === false && !isItemCutOW">
        <div class="col-12 totals font-weight-normal font-5">

            <div class="totals--cell delivery-qty">
                <div>
                    <label class="text-align-center mb-2">total quantity</label>
                    <span >{{ _orderItem.quantity }}</span>
                </div>
            </div>

            <div class="totals--cell">
                <div>
                    <label class="mb-2">subtotal</label>
                    <span class="price font-weight-normal"><app-currency-price [isItemCut]="isItemCutOW"
                            [price]="_orderItem.subTotal" [currency]="orderCurrency"
                            [solelySymbol]="true"></app-currency-price></span>
                </div>
            </div>

            <div class="totals--cell">
                <div class="text-center">
                    <label class="mb-2">Estimated Shipping</label>
                    <span class="price font-weight-normal"><app-currency-price [isItemCut]="isItemCutOW"
                            [price]="_orderItem.shippingTotal" [currency]="orderCurrency"
                            [solelySymbol]="true"></app-currency-price></span>
                </div>
            </div>

            <div class="totals--cell">
                <div [ngClass]="{'color-red' : taxExemptOrderHasTaxes}">
                    <label class="mb-2">
                        taxes
                        <i *ngIf="taxExemptOrderHasTaxes" class="fas fa-info-circle" placement="right"
                            tooltipClass="tooltips" ngbTooltip="{{ taxExemptReason }}"></i>
                    </label>
                    <span class="price font-weight-normal"><app-currency-price [isItemCut]="isItemCutOW" [price]="taxes"
                            [currency]="orderCurrency" [solelySymbol]="true"></app-currency-price></span>
                </div>
            </div>


            <div class="totals--cell">
                <div *ngIf="_orderItem.totalDiscount > 0">
                    <label class="mb-2">discount</label>
                    <div class="d-flex flex-row green align-items-baseline" [ngClass]="{'discount-error': hasDiscountErrors}">
                        <span>-&nbsp;</span>
                        <span class="price d-inline-block font-weight-normal">
                            <app-currency-price
                                [isItemCut]="isItemCutOW" [price]="_orderItem.totalDiscount"
                                [currency]="orderCurrency"></app-currency-price>
                        </span>
                    </div>
                </div>
            </div>

            <div class="totals--cell">
<!--                Budgets for single product  should be redone-->
                <div *ngIf="hasBudget && false">
                    <label class="mb-2">budget</label>
                    <div class="green">
                        <span *ngIf="_orderItem?.budget !== 0">-&nbsp;</span><span class="price d-inline-block font-weight-normal"><app-currency-price
                                [isItemCut]="isItemCutOW" [price]="_orderItem.budget"
                                [currency]="orderCurrency"></app-currency-price></span>
                    </div>
                </div>
            </div>

            <div class="totals--cell">
                <div>
                    <label class="font-weight-bold mb-2 text-center">total cost</label>
                    <span class="price">
                        <app-product-price *ngIf="hasValidDiscount"  [price]="_orderItem.totalCost"
                                           [originalPrice]="_orderItem.totalCost + _orderItem.totalDiscount"
                                           [showBothPrices]="_orderItem.totalDiscount > 0"
                                           [currency]="orderCurrency"></app-product-price>

                        <app-currency-price *ngIf="!hasValidDiscount" [isItemCut]="isItemCutOW"
                            [price]="financialTotalCost"
                            [currency]="orderCurrency"></app-currency-price>
                    </span>
                </div>
            </div>

        </div>

    </div>
    <div class="col col-lg-3 col-12 order-item--cost px-3">
        <div *ngIf="canDisplayEditControls" class="order-item--controls">
            <ng-container *ngIf="!restricted">
                <button *ngIf="canEditOrder" class="btn btn-outline-primary" (click)="handleEdit()"
                    [disabled]="_orderItem.product.active !== true || isItemCutOW">Edit</button>
                <a class="link link-underline small" (click)="onHandleRemove()" href="javascript:void(0)">Remove</a>
            </ng-container>
            <ng-container *ngIf="restricted">
                <button class="btn btn-primary mb-3" (click)="onHandleRemove(true)" [disabled]="removing">
                    <i *ngIf="removing" class="fal fa-sync rotate"></i>&nbsp;
                    Remove</button>
            </ng-container>
        </div>

    </div>

</ng-template>

<ng-template #mobileTotalsContainer>
    <div class="mt-3" [ngStyle]="{'visibility': hideFinancials ? 'hidden': 'initial'}"
        *ngIf="_orderItem.hidden === false && !isItemCutOW">
        <div class="totals font-weight-normal font-5">
            <div class="col-2 px-0 text-align-center">
                <label class="d-block text-align-center mb-2">QTY</label>
                <span class="font-weight-bold">{{_orderItem.quantity}}</span>
            </div>
            <div class="col-4 offset-6 px-0 text-align-center">
                <label class="d-block mb-2 uppercase">total cost</label>
                <span class="price font-3">
                    <app-product-price *ngIf="hasValidDiscount"  [price]="_orderItem.totalCost"
                                       [originalPrice]="_orderItem.totalCost + _orderItem.totalDiscount"
                                       [showBothPrices]="_orderItem.totalDiscount > 0"
                                       [currency]="orderCurrency"></app-product-price>

                        <app-currency-price *ngIf="!hasValidDiscount" [isItemCut]="isItemCutOW"
                                            [price]="financialTotalCost"
                                            [currency]="orderCurrency"></app-currency-price>

                </span>
            </div>

        </div>

    </div>
    <div class="col col-lg-3 col-12 order-item--cost px-3">
        <div *ngIf="canDisplayEditControls" class="order-item--controls">
            <ng-container *ngIf="!restricted">
                <button *ngIf="canEditOrder" class="btn btn-outline-primary" (click)="handleEdit()"
                    [disabled]="_orderItem.product.active !== true || isItemCutOW">Edit</button>
                <a class="link link-underline small" (click)="onHandleRemove()" href="javascript:void(0)">Remove</a>
            </ng-container>

            <ng-container *ngIf="restricted">
                <button class="btn btn-primary mb-3" (click)="onHandleRemove(true)" [disabled]="removing">
                    <i *ngIf="removing" class="fal fa-sync rotate"></i>&nbsp;
                    Remove</button>
            </ng-container>

        </div>

    </div>

</ng-template>

<ng-template #mobileReadOnlyView>
    <ng-container *ngIf="viewType === 'list-item'; else mobileReadonlyDetailedView">
        <div class="product-order-item__row">

            <div>
                <div class="image" *ngIf="product.media">
                    <img [src]="product.media | thumbnail" [alt]="product.label">
                </div>
                <div *ngIf="!isItemCutOW">
                    <div>
                        <app-product-order-item-price *ngIf="!product.hasVariations" [orderItem]="_orderItem" [ngClass]="'list-item'" [modal]="modal" fontSize="font-3">
                        </app-product-order-item-price>
                    </div>
                </div>
            </div>

            <div class="full-width">
                <!-- Render cancel message -->
                <ng-container *ngTemplateOutlet="cancelMessage; context: { itemCancelled: itemCancelled, cancelled: cancelled }"></ng-container>
                <!--header-->
                <app-product-order-item-header [orderItem]="_orderItem"
                                               [order]="_order"
                                               [viewType]="viewType"
                                               [showHideItemButton]="showHideItemButton"
                                               [showReorderButton]="showReorderButton"
                                               [showCustomizationButton]="showCustomizationButton"
                                               [readonly]="readonly" [modal]="modal"
                                               (changedVisibility)="onOrderItemChangeVisibility($event)"
                                               (editted)="onUpdate.emit()" (reorderItem)="reorderItem()">
                </app-product-order-item-header>
            </div>

        </div>

        <div>
            <ng-container *ngTemplateOutlet="mobileDevice ? placeOrderMobileView : placeOrderView"></ng-container>
        </div>
    </ng-container>


</ng-template>


<ng-template #mobileReadonlyDetailedView>
    <div class="d-flex align-items-start justify-content-between">
        <div>
            <app-product-order-item-price *ngIf="!product.hasVariations"
                [orderItem]="_orderItem" [ngClass]="'list-item'" [modal]="modal" fontSize="font-2">
            </app-product-order-item-price>
        </div>

        <div>
            <!-- Render cancel message -->
            <ng-container *ngTemplateOutlet="cancelMessage; context: { itemCancelled: itemCancelled, cancelled: cancelled }"></ng-container>
            <!--header-->
            <app-product-order-item-header [orderItem]="_orderItem"
                                           [order]="_order"
                                           [viewType]="viewType"
                                           [showHideItemButton]="showHideItemButton"
                                           [showReorderButton]="showReorderButton"
                                           [showCustomizationButton]="showCustomizationButton"
                                           [readonly]="readonly" [modal]="modal"
                                           (changedVisibility)="onOrderItemChangeVisibility($event)"
                                           (editted)="onEdited($event)" (reorderItem)="reorderItem()">
            </app-product-order-item-header>
        </div>

    </div>

    <div>
        <ng-container *ngTemplateOutlet="mobileDevice ? placeOrderMobileView : placeOrderView"></ng-container>
    </div>

</ng-template>


<ng-template #skuDescription let-sku="sku">
  <div class="mt-3 font-weight-bold">
    <ul class="sku--label my-0">
      <li *ngFor="let label of getVariationLabel(sku)">{{label}}</li>
      <li *ngIf="sku.urn" class="font-weight-normal font-5">URN: {{sku.urn}}</li>
      <li *ngIf="getVariationCodeInfo(sku) as codeInfo" class="font-weight-normal font-5">
        {{codeInfo.label}}: {{codeInfo.value}}
      </li>
    </ul>
  </div>
  <div class="order-item__variations--price text-align-right  px-0 pr-3" >
    <app-on-demand-sku-available-qty [orderItem]="_orderItem" [product]="product" [sku]="sku"
                                     viewType="detailed" fontSize="font-5">
    </app-on-demand-sku-available-qty>

    <app-product-order-item-in-stock *ngIf="!product.isBuyingWindow && !product.isEnabledAllocatedInventory" [product]="product" [sku]="sku"
                                     fontSize="font-5" viewType="sku-item" class="mb-2"></app-product-order-item-in-stock>
    <app-product-order-item-min-max *ngIf="showMinOrderInBody(sku)" [orderItem]="_orderItem"
                                    [product]="product" [showQuantityInSeparateLine]="true" [headerPosition]="false" [sku]="sku"
                                    viewType="detailed" fontSize="font-5">
    </app-product-order-item-min-max>

  </div>

</ng-template>
